import { Button, Icons } from '@commenda/kakashi';

export const SummaryInfoWrapper = ({
  title,
  onGoToForm,
  children,
}: {
  title: string;
  onGoToForm: () => void;
  children: React.ReactNode;
}) => {
  return (
    <div className="bg-bg-secondary rounded-lg p-2xl mb-2">
      <div className="flex justify-between">
        <h2 className="txt-extra-large-bold">{title}</h2>
        <Button
          size="sm"
          variant="tertiary"
          onClick={onGoToForm}
          className="underline"
        >
          <span>Go to form</span>
          <Icons.ArrowUpRight className="size-4" />
        </Button>
      </div>

      <div className="flex flex-col gap-6xl mt-2">{children}</div>
    </div>
  );
};
